import fetchExpresso from 'utility/fetchExpresso';

export async function getSeatCategories(eventId) {
    const response = await fetchExpresso(`/apiv2/events/${eventId}/seat-categories`);

    if (response.status === 200) {
        const seatCategories = await response.json();

        return seatCategories.categories || [];
    } else if (response.status === 400) {
        throw new Error(`[400] Bad request`);
    } else if (response.status === 500) {
        throw new Error(`[500] There was a problem on our end`);
    } else {
        throw new Error(`[${response.status}] Something went wrong`);
    }
}

export async function getSeatProducts(eventId) {
    const response = await fetchExpresso(`/apiv2/events/${eventId}/seat-products`);

    if (response.status === 200) {
        const seatProducts = await response.json();

        return seatProducts;
    } else if (response.status === 400) {
        throw new Error(`[400] Bad request`);
    } else if (response.status === 500) {
        throw new Error(`[500] There was a problem on our end`);
    } else {
        throw new Error(`[${response.status}] Something went wrong`);
    }
}
